import * as THREE from './vendor/three/three.module.js';

// The same lighting and materials are used by the product viewer and the live hero.
export function createFlaskEnvironment(renderer,scene){
 const studio=new THREE.Scene();studio.background=new THREE.Color(0x50544a);
 const panel=(x,y,z,w,h,power)=>{
  const mesh=new THREE.Mesh(new THREE.PlaneGeometry(w,h),new THREE.MeshBasicMaterial({color:new THREE.Color(power,power,power),side:THREE.DoubleSide}));
  mesh.position.set(x,y,z);mesh.lookAt(0,.65,0);studio.add(mesh);
 };
 panel(-3,2.8,4,.9,3.8,5);panel(3,1.8,1,.45,3.2,5);
 panel(-3,1,-1,.55,4,9);panel(3,1,-1,.5,4,8);panel(0,4,0,3,2,2);panel(0,1,-4,4,2,3);panel(0,-3,1,4,.45,4);
 const pmrem=new THREE.PMREMGenerator(renderer),environment=pmrem.fromScene(studio,.025);
 studio.traverse(o=>{o.geometry?.dispose();o.material?.dispose()});pmrem.dispose();
 scene.environment=environment.texture;scene.environmentIntensity=.85;
 scene.add(new THREE.HemisphereLight(0xfffbef,0x353829,.65));
 const key=new THREE.DirectionalLight(0xfffaf3,2.2);key.position.set(-4,6,8);scene.add(key);
 if(innerWidth>900){
  renderer.shadowMap.enabled=true;renderer.shadowMap.type=THREE.PCFSoftShadowMap;
  key.castShadow=true;key.shadow.mapSize.set(2048,2048);
  Object.assign(key.shadow.camera,{left:-8,right:8,top:7,bottom:-7,near:.1,far:35});
  key.shadow.normalBias=.008;key.shadow.bias=-.00015;
 }
 const fill=new THREE.DirectionalLight(0xf4f9ff,.8);fill.position.set(5,2,4);scene.add(fill);
 return environment;
}
export function prepareFlaskMaterials(root,renderer){
 const seen=new Set(),anisotropy=Math.min(8,renderer.capabilities.getMaxAnisotropy());
 root.traverse(mesh=>{
  if(!mesh.isMesh)return;
  const m=mesh.material,isGlass=/glass/i.test(m.name);
  mesh.castShadow=!isGlass;mesh.receiveShadow=!isGlass;
  if(isGlass)mesh.renderOrder=2;
  if(seen.has(m))return;seen.add(m);
  for(const value of Object.values(m))if(value?.isTexture){value.anisotropy=anisotropy;value.needsUpdate=true;}
  if(isGlass){
   // A polished optical shell, not a low-resolution refraction buffer: the ingredients
   // are rendered at full canvas resolution even through overlapping flasks.
   m.transmission=0;m.thickness=0;m.transparent=true;m.opacity=1;m.depthWrite=false;
   m.color.set(0x030404);m.roughness=.02;m.ior=1.46;m.envMapIntensity=1.25;
   m.specularIntensity=1;m.clearcoat=0;m.side=THREE.FrontSide;
   // Add reflected light while transmitting the crisp scene beneath it.
   m.blending=THREE.CustomBlending;m.blendEquation=THREE.AddEquation;m.blendSrc=THREE.OneFactor;m.blendDst=THREE.OneMinusSrcAlphaFactor;
   m.onBeforeCompile=shader=>{
    shader.fragmentShader=shader.fragmentShader.replace('#include <opaque_fragment>',`
     float glassEdge = pow(1.0 - abs(dot(normalize(normal), normalize(vViewPosition))), 4.0);
     diffuseColor.a = clamp(0.025 + glassEdge * 0.8, 0.025, 0.85);
     outgoingLight *= mix(0.16, 0.65, glassEdge);
     #include <opaque_fragment>
    `);
   };
   m.customProgramCacheKey=()=> 'pizza-lab-clear-natural-v4';
  }else{
   m.envMapIntensity=.4;m.side=/basil|calyx/i.test(m.name)?THREE.DoubleSide:THREE.FrontSide;
   // Respect the authored v4 roughness/clearcoat once packed PBR maps are present.
   if(m.roughnessMap)return;
   if(/tomato/i.test(m.name)){
    m.roughness=m.roughnessMap?1:.3;m.clearcoat=.16;m.clearcoatRoughness=.23;
   }else if(/mozzarella/i.test(m.name)){
    m.roughness=m.roughnessMap?1:.44;m.clearcoat=.12;m.clearcoatRoughness=.3;
   }else if(/basil/i.test(m.name)){
    m.roughness=m.roughnessMap?1:.4;m.clearcoat=.09;m.clearcoatRoughness=.3;
   }
  }
 });
}
export function disposeFlaskResources(root){
 const geometry=new Set(),materials=new Set(),textures=new Set();
 root?.traverse(n=>{n.shadow?.dispose?.();if(n.geometry)geometry.add(n.geometry);if(n.material)for(const m of Array.isArray(n.material)?n.material:[n.material])materials.add(m)});
 materials.forEach(m=>{for(const value of Object.values(m))if(value?.isTexture)textures.add(value);m.dispose()});
 geometry.forEach(g=>g.dispose());textures.forEach(t=>{t.dispose();t.source?.data?.close?.()});
}
